import * as API from '@siloreal:shared:api';

const SILOBAG_MONITORING_ENDPOINT = '/silobags/monitoring';

export type ListMonitoredSilobagProtocolsServiceContract = {
  silobagIds: readonly string[];
  signal?: AbortSignal;
};

export type SilobagProtocol = {
  id: number;
  silobag_id: string;
  silobag_protocol_types_id: number;
  silobag_protocol_clients_id: number | null;
  active: boolean;
  created_at: string;
  updated_at: string;
};

export type MonitoredSilobagProtocol = {
  silobag_id: string;
  is_monitored: boolean;
  protocol: SilobagProtocol | null;
};

export async function listMonitoredSilobagProtocolsService(
  contract: ListMonitoredSilobagProtocolsServiceContract
): Promise<MonitoredSilobagProtocol[]> {
  const silobagIds = [...new Set(contract.silobagIds.map((id) => id.trim()).filter(Boolean))];
  if (silobagIds.length === 0) return [];

  const queryParameters = new URLSearchParams();
  queryParameters.set('ids', silobagIds.join(','));

  const { data } = await API.http.fetch.get<MonitoredSilobagProtocol[]>(SILOBAG_MONITORING_ENDPOINT, {
    query: `?${queryParameters}`,
    signal: contract.signal,
  });

  return data;
}
